export default __webpack_public_path__ + "static/media/weight_male.4805acd8.png";